module.exports = __webpack_public_path__ + "img/behance-circle.74c53979.svg";